export const ENUM_USER_TYPE = {
  ADMIN: 0,
  RXP: 1,
  MFG: 2,
  CUSTOMER: 3,
  CE: 4,
  TPA: 5,
  PHARMACY: 6,
  UNKNOWN: 999
} as const;
